import React, { useEffect, useState } from 'react'

import { HttpService, API, Title, DateFormat, Spinner, ExportToExcel } from '../../config/react'
import DataTable from 'react-data-table-component'
import ContactDetail from './ContactDetail'
const ContactForm = () => {
  const [ContactFormList, setContactFormList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [ContactData, setContactData] = useState()
  const [IsShowModal, setIsShowModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [SearchTerm, setSearchTerm] = useState('')

  const columns = [
    {
      name: 'Name',
      sortable: true,
      sortField: 'name',
      wrap: true,
      selector: (row) => row.name
    },
    {
      name: 'Email',
      sortable: true,
      sortField: 'email',
      wrap: true,
      selector: (row) => row.email
    },
    {
      name: 'Contact Number',
      sortable: true,
      sortField: 'phone',
      wrap: true,
      selector: (row) => row.phone
    },
    {
      name: 'Message',
      selector: (row) => row.message
    },
    {
      name: 'Created Date',
      sortable: true,
      wrap: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="cursor action-btn">
          <span
            onClick={(e) => ShowDetail(e, row.id)}
            className="text-dark"
            title="View"
          >
            <i
              className="mdi mdi-eye"
              aria-hidden="true"
            ></i>{' '}
          </span>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const GetContactFormList = () => {
    const contactformData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // console.log(contactformData);
    setLoading(true)
    HttpService.postApi(API.GetContactFormAdminList, contactformData).then((response) => {
      // setContactFormList(response.data.result[0])
      setLoading(false)

      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];
        // console.log(data);
        setContactFormList(data)
        settotalRows(response.data.result[0][0].total_form)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ContactForm
    GetContactFormList()
  }, [CustomFilters, SearchTerm])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    // console.log('LN 98 Page 1'+' &page_size '+e);
  }
  const ShowDetail = (e, id) => {
    e.preventDefault()
    const data = ContactFormList.filter((x) => x.id === id)[0]
    setContactData(data)
    setIsShowModal(true)
    setForceUpdate(!isForceUpdate)
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name, Email, Contact Number, Message."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })
  const handleSort = (e, direction) => {
    // console.log('LN 95 Sort FIeld ' + e.sortField);
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const onCloseModal = () => {
    setIsShowModal(false)
    setForceUpdate(!isForceUpdate)
  }
  const handleExportExcel = () => {
    HttpService.getApi(API.GetContactFormListExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Contact Us')
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <>
      {IsShowModal === true && (
        <ContactDetail
          props={{ IsShowModal, data: ContactData }}
          onCloseModal={onCloseModal}
        />
      )}
      <div className="content-wrapper pb-0">
        <div className="page-header">
          <h3 className="page-title"> {Title.ContactForm} </h3>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <button
                  className="btn btn-primary float-right m-1"
                  onClick={handleExportExcel}
                >
                  Export Excel
                </button>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={ContactFormList}
                    pagination
                    paginationServer
                    persistTableHead={true}
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    onSort={handleSort}
                    progressPending={loading}
                    progressComponent={<Spinner />}
                    sortServer
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default ContactForm
